export const CONTRACT_NETWORK_STATUSES = {
    IN_NETWORK: 'In-Network',
    OON_MORE_THAN_50_BENEFITS: 'Out of Network: >50% Benefits',
    OON_INELIGIBLE: 'Out of Network: Ineligible',
    OON_PRIOR_AUTH_REQUIRED: 'Out of Network: Prior Auth Required',
    IN_CONTRACT_REVIEW: 'In Contract Review',
    TPA: 'TPA (Catheter, Wound)',
    DIRECT_BILL: 'Direct Bill',
};
